import { createSlice } from "@reduxjs/toolkit";

const mediaSlice = createSlice({
    name: "media",
    initialState: {},
    reducers: {
        registerMedia: (state, action) => {
            const media = action.payload;

            if (!media?.id) return;

            // Only add if not already present
            if (!state[media.id]) {
                state[media.id] = media;
            } else {
                console.warn(
                    `⚠️ Media ${media.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterMedia: (state, action) => {
            action.payload.forEach((media) => {
                if (!media?.id) return;

                if (!state[media.id]) {
                    state[media.id] = media;
                } else {
                    console.warn(
                        `⚠️ Media ${media.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const { registerMedia, bulkRegisterMedia } = mediaSlice.actions;

export default mediaSlice.reducer;
